module.exports = __webpack_public_path__ + "static/media/messages-cercle.e99f9120.png";